import { render, staticRenderFns } from "./NumberConfigComponent.vue?vue&type=template&id=25993888&scoped=true&"
import script from "./NumberConfigComponent.vue?vue&type=script&lang=js&"
export * from "./NumberConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25993888",
  null
  
)

export default component.exports